<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { usePlanLimits } from 'dashboard/composables/usePlanLimits';

const router = useRouter();
const { limitModal, hideLimitExceededModal, getResourceLabel } = usePlanLimits();

const resourceLabel = computed(() => getResourceLabel(limitModal.value.resourceType));

const iconClass = computed(() => {
  const icons = {
    agents: 'i-lucide-users',
    inboxes: 'i-lucide-inbox',
    bots: 'i-lucide-bot',
  };
  return icons[limitModal.value.resourceType] || 'i-lucide-alert-triangle';
});

const goToBilling = () => {
  hideLimitExceededModal();
  router.push({ name: 'omni_billing' });
};
</script>

<template>
  <Teleport to="body">
    <div
      v-if="limitModal.show"
      class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60"
      @click.self="hideLimitExceededModal"
    >
      <div
        class="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-md shadow-2xl overflow-hidden"
        @click.stop
      >
        <!-- Header with gradient -->
        <div class="bg-gradient-to-r from-amber-500 to-orange-500 p-6">
          <div class="flex items-center gap-4">
            <div class="flex items-center justify-center w-14 h-14 bg-white/20 rounded-full">
              <span :class="[iconClass, 'w-7 h-7 text-white']" />
            </div>
            <div>
              <h3 class="text-xl font-bold text-white">
                Limite Atingido
              </h3>
              <p class="text-amber-100 text-sm">
                {{ resourceLabel }}
              </p>
            </div>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6">
          <p class="text-slate-600 dark:text-slate-300 mb-4">
            {{ limitModal.message }}
          </p>

          <!-- Stats -->
          <div class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 mb-6">
            <div class="flex justify-between items-center">
              <div class="text-center flex-1">
                <div class="text-2xl font-bold text-slate-800 dark:text-white">
                  {{ limitModal.current }}
                </div>
                <div class="text-xs text-slate-500 dark:text-slate-400">
                  Em uso
                </div>
              </div>
              <div class="h-10 w-px bg-slate-200 dark:bg-slate-700" />
              <div class="text-center flex-1">
                <div class="text-2xl font-bold text-amber-600 dark:text-amber-400">
                  {{ limitModal.limit === -1 ? '∞' : limitModal.limit }}
                </div>
                <div class="text-xs text-slate-500 dark:text-slate-400">
                  Limite do plano
                </div>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex gap-3">
            <button
              class="flex-1 px-4 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-300 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 rounded-lg transition-colors"
              @click="hideLimitExceededModal"
            >
              Fechar
            </button>
            <button
              class="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-woot-600 hover:bg-woot-700 rounded-lg transition-colors flex items-center justify-center gap-2"
              @click="goToBilling"
            >
              <span class="i-lucide-rocket w-4 h-4" />
              Fazer Upgrade
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
